export default __webpack_public_path__ + "static/media/atlas-i.707ea5a6.jpeg";